exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upgradeTokenForm input.form-control{display:inline-block;width:9em;margin-right:5px}.upgradeTokenForm .errorDisplay{max-width:18em}.upgradeTokenForm .spinnerBox.placeholder{display:inline-block;padding:7px 20px}.upgradeTokenForm .codeField{display:inline-block;width:45%;text-align:left}.upgradeTokenForm .buttonArea{display:inline-block;width:55%;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/upgrade/upgrade_token_form.scss
// module id = 1457
// module chunks = 0